import React, { useState } from "react";
import { formatPhone } from "../../utils";
import { Bounce, toast, ToastContainer } from "react-toastify";

export default function ContatosSplit({ siteContent }) {
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    message: "",
    name: ""
  })

  const handleDisabled = () => {
    if (!formData.phone || !formData.email || !formData.message || !formData.name) {
      return true
    }
    return false
  }

  const handlePhoneChange = (e, field) => {
    const value = e.target.value
    setFormData((prevState) => ({
      ...prevState,
      [field]: formatPhone(value)
    }));
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value
    setFormData((prevState) => ({
      ...prevState,
      [field]: value
    }));
  };

  const getTheme = () => {
    return localStorage.getItem("theme")
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const form = e.target;

    const safeMessage = form.message.value
      .replace(/<[^>]*>?/gm, "") // remove HTML
      .trim();

    const data = {
      name: form.name.value,
      email: form.email.value,
      message: safeMessage,
      phone: form.phone.value,
    };

    if (handleDisabled()) {
      toast.warning('Todos os campos precisam estar preenchidos!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: getTheme(),
        transition: Bounce,
      });
      return ''
    }

    if (form.message.value.length > 1000) {
      toast.warning('Mensagem muito longa!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: getTheme(),
        transition: Bounce,
      });
      return ''
    }

    const res = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    if (res.ok) {
      toast.success('Mensagem enviada!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: getTheme(),
        transition: Bounce,
      });
      setFormData({
        phone: "",
        email: "",
        message: "",
        name: ""
      })
    } else {
      toast.error('Erro ao enviar mensagem!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: getTheme(),
        transition: Bounce,
      });
    }
  }

  return (
    <div className="contacts">
      <div className="card__contactCard">
        <h3 className="card__title">Redes Sociais</h3>

        {siteContent && siteContent.map((social) => (
          <a href={social?.url} target="_blank" key={social?.name} className="contactRow" rel="noreferrer">
            <span className="contactRow__icon" aria-hidden="true">
              <img src={social?.icon?.url} alt={social?.name} />
            </span>
            <span className="contactRow__text">{social?.name}</span>
          </a>
        ))}

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={getTheme()}
          transition={Bounce}
        />
      </div>
      <form className="card formCard" onSubmit={handleSubmit}>
        <div className="formGrid">
          <input className="input name" onChange={(e) => handleInputChange(e, 'name')} value={formData?.name} name="name" placeholder="Nome" autoComplete="off" />
          <input className="input email" onChange={(e) => handleInputChange(e, 'email')} type="email" value={formData?.email} name="email" placeholder="E-mail" autoComplete="off" />
          <input className="input phone" name="phone" onChange={(e) => handlePhoneChange(e, 'phone')} value={formData?.phone} maxLength={15} placeholder="Telefone" autoComplete="off" />
          <textarea className="input textarea" onChange={(e) => handleInputChange(e, 'message')} value={formData?.message} name="message" placeholder="Mensagem" autoComplete="off" />
          <input type="text" name="_gotcha" style={{ display: "none" }} tabIndex="-1" autoComplete="off" />
        </div>
        <button className="btn btn--primary btn--full" type="submit" disabled={handleDisabled()}>
          ENVIAR
        </button>
      </form>
    </div>
  );
}